import Resource from '@/api/resource'
import request from '@/utils/request'
import store from '@/store/index'

class Logs extends Resource {
  constructor() {
    super('logs')
  }

  listLogs(query) {
    return request({
      url: '/experiment-sessions/index',
      method: 'post',
      data: query,
    })
  }
}

export { Logs as default }
